import React from 'react';
import navigationConfig from './dmsNavigationConfig';
import RenderNavItems from '../common/renderNavItems';

const DMSSidebarOptions = () => {
  return <RenderNavItems config={navigationConfig} />;
};

export default DMSSidebarOptions;
